// extracted by mini-css-extract-plugin
export default {"addBtn":"styles_addBtn__vb27h"};